import { BorderBottom } from '@mui/icons-material';

export const getStyled = (theme) => ({
  mainWrapper: {
    background: '#eee',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',

    '@media (maxWidth: 600px)': {
      position: 'fixed',
      bottom: 0,
      width: '100%',
    },
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '25%',
  },
  dropInfo: {
    background: '#eee',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: 'none',
  },
  gridFiles: {
    maxHeight: '100%',
    overflow: 'scroll',
  },
  newMessageBox: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#15202B',
    width: '100%',
    display: 'flex',
    padding: '7px',
    alignItems: 'center',
  },
  messageInputWrapper: {
    padding: 6,
    marginLeft: 5,
    marginRight: 7,
    backgroundColor: theme.palette.mode === 'light' ? '#eeeeee' : '#192733',
    display: 'flex',
    borderRadius: 20,
    flex: 1,
    position: 'relative',
    color: theme.custom.colors.text,
  },
  messageInputWrapperPrivate: {
    padding: 6,
    marginRight: 7,
    background: '#F0E68C',
    display: 'flex',
    borderRadius: 20,
    flex: 1,
    position: 'relative',
  },
  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: 'none',
    fontFamily: 'Tahoma, sans-serif',
    color: theme.custom.colors.text,
  },
  messageInputPrivate: {
    paddingLeft: 10,
    flex: 1,
    border: 'none',
    color: '#808080',
  },
  sendMessageIcons: {
    color: '#808080',
  },
  ForwardMessageIcons: {
    color: '#808080',
    transform: 'scaleX(-1)',
  },
  uploadInput: {
    display: 'none',
  },
  viewMediaInputWrapper: {
    maxHeight: '100%',
    display: 'flex',
    padding: '10px 13px',
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.mode === 'light' ? '#eeeeee' : '#192733',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  emojiBox: {
    position: 'absolute',
    bottom: 63,
    width: 40,
    borderTop: '1px solid #e8e8e8',
  },
  circleLoading: {
    color: '#008000',
    opacity: '70%',
    position: 'absolute',
    top: '20%',
    left: '50%',
    marginLeft: -12,
  },
  audioLoading: {
    color: '#008000',
    opacity: '70%',
  },
  recorderWrapper: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'middle',
    color: theme.custom.colors.text,
    fontWeight: 500,
  },
  cancelAudioIcon: {
    color: theme.custom.colors.cancelButton,
  },
  sendAudioIcon: {
    color: theme.custom.colors.confirmButton,
  },
  replyginMsgWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
    paddingBottom: 8,
    backgroundColor: theme.custom.colors.optionsBackground,
    borderBottom: 'solid 1px #666666',
  },
  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: 'hidden',
    backgroundColor: theme.palette.mode === 'light' ? '#eeeeee' : '#192733',
    borderRadius: '7.5px',
    display: 'flex',
    position: 'relative',
  },
  replyginMsgBody: {
    padding: 10,
    height: 'auto',
    display: 'block',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    color: theme.custom.colors.text,
  },
  replyginContactMsgSideColor: {
    flex: 'none',
    width: '4px',
    backgroundColor: theme.palette.mode === 'light' ? '#098f5e' : '#35cd96',
  },
  replyginSelfMsgSideColor: {
    flex: 'none',
    width: '4px',
    backgroundColor: theme.palette.mode === 'light' ? '#065183' : '#6bcbef',
  },
  messageContactName: {
    display: 'flex',
    color: theme.palette.mode === 'light' ? '#065183' : '#6bcbef',
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: 'absolute',
    bottom: '50px',
    background: theme.custom.colors.defaultBackground,
    border: `solid 1px ${theme.custom.colors.text}`,
    borderRadius: 6,
    left: 0,
    width: '100%',
  },
  messageQuickAnswersWrapperItem: {
    width: '100%',
    listStyle: 'none',
    padding: '3px 0',
  },
  messageQuickAnswersWrapperLink: {
    padding: '5px 10px',
    width: '100%',
    borderRadius: 1,

    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'light'
          ? 'rgb(189, 189, 189, 0.7)'
          : 'rgb(189, 189, 189, 0.5)',
      cursor: 'pointer',
    },
  },
  invertedFabMenu: {
    border: 'none',
    borderRadius: 50,
    boxShadow: 'none',
    padding: theme.spacing(1),
    backgroundColor: 'transparent',
    color: 'grey',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:disabled': {
      backgroundColor: 'transparent !important',
    },
  },
  invertedFabMenuMP: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
    backgroundColor: 'transparent',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  invertedFabMenuCont: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    minHeight: 'auto',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
    backgroundColor: 'transparent',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  invertedFabMenuMeet: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    minHeight: 'auto',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
    backgroundColor: 'transparent',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  invertedFabMenuDoc: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
    backgroundColor: 'transparent',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  invertedFabMenuCamera: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
    backgroundColor: 'transparent',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  flexContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  flexItem: {
    flex: 1,
  },
  timerBox: {
    display: 'flex',
    marginLeft: 10,
    marginRight: 10,
    alignItems: 'center',
  },
  menuProps: {
    paper: {
      sx: {
        backgroundColor: theme.custom.colors.defaultBackground,
        color: theme.custom.colors.text,
      },
    },
  },
});
